import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconRadioSelected from '../../../../../icons/icon-radio-selected.svg';
import IconRadioUnselected from '../../../../../icons/icon-radio-unselected.svg';


const LocationType = function LocationType({
  locationType,
  locationTypeOptions,
  updateFormValues,
  content,
}) {
  const { optionalQuestionLabel } = content;

  return (
    <fieldset className="opco-nav-form__location-type-container">
      <legend className="opco-nav-form__field-label">
        {optionalQuestionLabel}
      </legend>
      <div className="opco-nav-form__location-type">
        { locationTypeOptions.map((option) => {
          const selected = locationType === option;
          const IconComponent = selected ? IconRadioSelected : IconRadioUnselected;
          const locationTypeRadioClasses = classNames({
            'opco-nav-form__location-type-radio': true,
            'opco-nav-form__location-type-radio-selected': selected,
          });

          return (
            <label
              className={locationTypeRadioClasses}
              htmlFor={`${option}-input`}
              key={option}
            >
              <div className="opco-nav-form__selected-icon">
                <IconComponent className="radio__icon" />
              </div>
              {option}
              <input
                className="opco-nav-form__location-type-radio--input"
                type="radio"
                id={`${option}-input`}
                name="location-type"
                value={option}
                onChange={() => updateFormValues({ locationType: option })}
              />
            </label>
          );
        })}
      </div>
    </fieldset>
  );
};

LocationType.propTypes = {
  locationType: PropTypes.string.isRequired,
  locationTypeOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  updateFormValues: PropTypes.func.isRequired,
  content: PropTypes.shape({
    optionalQuestionLabel: PropTypes.string,
  }).isRequired,
};

export default LocationType;
